import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getPageContents } from "../../../actions/admin/cmspage";
import { useLoading } from "../../../components/LoadingContext";
import { BookSection } from "../../../components/book-section/BookSection";
import Disclaimer from "../../../components/disclaimer";
import FrontLayout from "../../../components/layout-new-theme/FrontLayout";
import { cn } from "../../../utils/classnames";
import { createTypographyHelper } from "../../../utils/typography";
import VehicleCard from "./_components/VehicleCard";
import { Stagger } from "../../../components/motion";

const OurFleetBanner = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/our-fleets/our-fleet-banner.jpg";

const Fleet = () => {
  const page_name = "cms-fleet";
  const dispatch = useDispatch();
  const history = useHistory();
  const cmspage_state = useSelector((state) => state.cmspage);
  const { cmspage, loading } = cmspage_state;
  const { t, i18n } = useTranslation();
  useEffect(() => {
    dispatch(getPageContents(page_name));
  }, [dispatch]);
  const { showLoading, closeLoading } = useLoading();

  const getTypographyClass = createTypographyHelper(i18n.language);

  const getLinkDetail = (name) => {
    switch (name) {
      case "Toyota Alphard":
        return './fleet-types?type=ToyotaAlphard';
        break;
      case "Toyota GranAce":
        return "./fleet-types?type=ToyotaGranAce";
        break;
      case "Toyota HiAce Grand Cabin":
        return "./fleet-types?type=ToyotaHiAceGrandCabin";
        break;
      case "Toyota HiAce Luxury Cabin":
        return "./fleet-types?type=ToyotaHiAceLuxuryCabin";
        break;
      case "Mercedes Benz V-Class":
        return "./fleet-types?type=MercedesBenzVClass";
        break;
      case "Mercedes Benz S-Class":
        return "-";
        break;
      case "Toyota Alphard WELL Cabin Luxe":
        return "-";
        break;
      case "WELL Cabin Granluxe":
        return "./fleet-types?type=WELLCabinGranLuxe";
        break;
      case "WELL Cabin GranLuxe":
        return "./fleet-types?type=WELLCabinGranLuxe";
        break;

      default:
        break;
    }
  };

  return (
    <FrontLayout>
      {loading ? showLoading(true) : closeLoading(true)}
      <div className="tw:relative tw:max-w-[1920px] tw:mx-auto">
        {/* <!-- hero --> */}

        <div className="tw:max-w-[1920px] tw:m-auto tw:relative">
          <div className="tw:bg-[linear-gradient(37.52deg,rgba(33,37,41,0.5)_7.63%,rgba(33,37,41,0.25)_29.62%)] tw:lg:bg-[linear-gradient(87.06deg,#000000_6.43%,rgba(40,42,45,0.3)_46.3%)] tw:w-full tw:h-full tw:absolute tw:top-0 tw:left-0"></div>
          <img
            src={OurFleetBanner}
            alt="Our fleet banner"
            className="tw:w-full tw:h-[430px] tw:lg:h-[430px] tw:object-cover"
          />
          <div className="tw:absolute tw:left-5 tw:bottom-8 tw:lg:left-[82px] tw:lg:bottom-[65px] tw:space-y-[14px] tw:z-50">
            <div className="tw:text-[rgba(219,190,120,1)] tw:text-[8px] tw:tracking-[3px] tw:font-semibold tw:font-hanken-grotesk tw:leading-none tw:uppercase">
              {t("Fleet")}
            </div>
            <div className="tw:text-[34px] tw:lg:text-[45px] tw:font-libre-caslon-display tw:leading-[58px] tw:text-white tw:font-normal tw:capitalize">
              {t("Fleet.Heading")}
            </div>
            <div
              className={cn(
                "tw:font-hanken-grotesk tw:text-[#DADADA] tw:mt-3 tw:lg:text-base tw:lg:leading-normal",
                getTypographyClass(14)
              )}
            >
              {t("Fleet.Intro")}
            </div>
          </div>
        </div>

        {/*<!-- section 3, vehicles --> */}
        <div className="tw:px-5 tw:lg:px-[75px] tw:mt-12 tw:lg:mt-[88px] tw:mb-12 tw:lg:mb-[100px]">

          <Stagger
            className="tw:grid tw:grid-cols-1 tw:lg:grid-cols-2 tw:2xl:grid-cols-3 tw:md:[grid-auto-rows:1fr] tw:gap-x-4 tw:gap-y-4 tw:md:gap-y-[22px]"
            stagger={0.08}
            viewport={{ amount: 0.05 }}
          >
            {cmspage?.additionalContent
              ?.sort((a, b) => a.prioritize - b.prioritize)
              .map((v) => (
                <VehicleCard
                  key={v.typename}
                  v={v}
                  onClick={() => {
                    if (getLinkDetail(v.typename) !== "-") {
                      history.push(getLinkDetail(v.typename));
                    }
                  }}
                />
              ))}
          </Stagger>
          <div className="tw:mt-6 tw:lg:mt-4 tw:lg:pt-2">
            <div className="bg-gold-grey-F9F9F9 tw:p-6 tw:mt-4 tw:rounded-[0.5rem]">
              <div
                className="tw:overflow-auto custom-scrollbar"
                style={{ height: "auto" }}
              >
                <Disclaimer
                  textClassName={'tw:!text-[14px] tw:!text-[#4E4E4E] tw:!text-[400]'}
                  p4ClassName={'tw:!mb-0'}
                  withTitle={true}
                />
              </div>
            </div>
          </div>
        </div>

        {/* <!-- section 3 end --> */}
        {/* <!-- banner --> */}
        <BookSection />
      </div>
    </FrontLayout>
  );
};

export default Fleet;
